<template>
  <section></section>
</template>

<script>
export default {
  data() {
    return {
      uploader: null,
      endpoint: "https://oss-accelerate.aliyuncs.com",
      //   endpoint: "http://oss-cn-hangzhou.aliyuncs.com",
      bucket: "mana-video",
      userData: '{"Vod":{}}',
      objectPre: "/upload"
    };
  },
  props: [
    "uploadVideoProgress",
    "beforeUploadVideo",
    "uploadVideoFail",
    "uploadVideoSuccess",
    "getDuration"
  ],
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.uploader = this.createUploader();
      const {
        accessKeyId,
        accessKeySecret,
        securityToken,
        expiration
      } = await this.getToken();
      this.uploader.init(
        accessKeyId,
        accessKeySecret,
        securityToken,
        expiration
      );
    },
    getToken() {
      const url = `/api/u/video/getAliToken`;
      return this.$http.get(url).then(res => {
        if (res.code === "OK") {
          return res.data;
        }
      });
    },
    createUploader() {
      const self = this;
      const uploader = new VODUpload({
        //分片大小默认1M，不能小于100K
        partSize: 1048576,
        //并行上传分片个数，默认5
        parallel: 5,
        //网络原因失败时，重新上传次数，默认为3
        retryCount: 3,
        //网络原因失败时，重新上传间隔时间，默认为2秒
        retryDuration: 2,
        // 文件上传成功
        onUploadSucceed: function(uploadInfo) {
          self.$emit("uploadVideoSuccess", uploadInfo.object);
        },
        // 文件上传失败
        onUploadFailed: function(uploadInfo, code, message) {
          self.$emit("uploadVideoFail", message);
        },
        // 文件上传进度，单位：字节
        onUploadProgress: function(uploadInfo, totalSize, uploadedSize) {
          self.$emit(
            "uploadVideoProgress",
            ((uploadedSize * 100) / totalSize).toFixed(0)
          );
        },
        // 上传凭证超时
        onUploadTokenExpired: async function(uploadInfo) {
          const {
            accessKeyId,
            accessKeySecret,
            securityToken,
            expiration
          } = await self.getToken();

          uploader.resumeUploadWithToken(
            accessKeyId,
            accessKeySecret,
            securityToken,
            expiration
          );
        },
        // 开始上传
        onUploadstarted: function(uploadInfo) {
          // console.info("onUploadstarted", uploadInfo);
          const file = uploadInfo.file;
          const url = URL.createObjectURL(file);
          const audioElement = new Audio(url);
          audioElement.addEventListener("loadedmetadata", function(_event) {
            const duration = audioElement.duration;
            self.$emit("getDuration", duration);
          });
          self.$emit("beforeUploadVideo", uploadInfo.file.name);
        }
      });
      return uploader;
    },
    addFile(file) {
      const type = "." + file.type.split("/")[1];
      this.uploader.addFile(
        file,
        this.endpoint,
        this.bucket,
        this.objectPre + "/" + this.randomString(4) + type,
        this.userData
      );
      this.uploader.startUpload();
    },
    randomString(len = 32) {
      const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      const maxPos = chars.length;
      let pwd = "";
      for (let i = 0; i < len; i += 1) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd + Date.now();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/uploadVideo/uploadVideo.vue